import type { UserProfile } from "~/modules/user/models/UserProfile.interface";

export function isProfileAuthorized(
  profileList: UserProfile[],
  userProfileId: string,
) {
  return profileList.find((profile) => profile.id === userProfileId)
    ?.isAuthorized;
}
